// GA4（仅浏览器 / PWA）：VITE_GA4_MEASUREMENT_ID 未设 = 完全 no-op（本地/CI/自托管默认形态）。
// 门控三条件（shouldLoadAnalytics，纯函数便于单测）：
//   1) 有 measurement id；
//   2) 非桌面壳 —— 2026-09-16 实测 macOS 版收不到数据：Tauri macOS 页面固定跑在
//      tauri://localhost，而 gtag.js 在 location.protocol 非 http/https 时中止所有 hit
//      （App 内 init 确实跑了，GA 实时报告仍为 0）。Tauri 的 useHttpsScheme 只作用于
//      Windows/Android；localhost 插件官方警告安全风险且会换 localStorage 位置（桌面用户本地
//      数据与未同步编辑「消失」）。决定：macOS 版暂不接 GA，GA 媒体资源「DoneLine macOS」保留未用。
//      将来要接，只能绕过 gtag.js 直接发（Measurement Protocol 或 /g/collect）；
//   3) 尊重浏览器 Do Not Track。
// 隐私姿态：GA4 默认不记完整 IP；不发送 user_id / 任何任务内容。SPA 翻页依赖 GA4
// 增强测量的 history 监听（TanStack Router 走标准 pushState，可被捕获）。

type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: GtagFn;
  }
}

export function shouldLoadAnalytics(opts: {
  measurementId: string | undefined;
  isDesktop: boolean;
  doNotTrack: string | null | undefined;
}): boolean {
  if (!opts.measurementId) return false;
  if (opts.isDesktop) return false;
  if (opts.doNotTrack === '1' || opts.doNotTrack === 'yes') return false;
  return true;
}

export function initGa4(measurementId: string, doc: Document = document): void {
  if (window.gtag) return; // 幂等：重复调用不注入第二份
  window.dataLayer = window.dataLayer ?? [];
  const gtag: GtagFn = function gtag() {
    // gtag.js 只识别 dataLayer 里的 **arguments 对象**（官方 snippet 的写法）；推普通数组
    // 会被当成 dataLayer 命令数组处理，config / event 静默丢失 —— 旧实现推的就是数组，
    // 即使配了测量 ID 也收不到数据。
    // eslint-disable-next-line prefer-rest-params -- gtag.js 依赖 arguments 对象形态，不能改 rest 参数
    window.dataLayer?.push(arguments);
  };
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId);

  const script = doc.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  doc.head.appendChild(script);
}
